import DOMPurify from "dompurify";
import firebase from "firebase/compat/app";
import {
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline";
import { useCallback, useContext, useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DeleteIcon, InfoIcon } from "../../../Constants";
import { db } from "../../../firebase";
import { firebaseAuth } from "../../../providers/AuthProvider";
import {
  CTA_BUTTON_DESTINATIONS,
  getCTAButtonDestination,
  getCTAButtonDestinationOptions,
} from "../../../utils/eventPresentation";
import { CurrentEventDataContext } from "../CurrentEventDataContext";
import VisualEditorModal from "./VisualEditorModal";

// import * as Sentry from "@sentry/react";
export const EventCTAItem = ({
  id,
  item,
  index,
  isExpanded = false,
  moveCard,
  onRemove,
  onToggleExpanded,
  totalItems = 0,
  updateData,
  eventData,
  setEventData,
}) => {
  // const [ eventData, setEventData ] = useState(tmpEventData);
  const { setCurrentEventData } = useContext(CurrentEventDataContext);
  useContext(firebaseAuth);
  const ref = useRef(null);
  const history = useNavigate();
  const [editCopy, setEditCopy] = useState(null)
  const [help, setHelp] = useState({});
  const handleChangeItem = useCallback((idkey, value) => {
    // console.log(idkey,value);
    // let tmpInputs = {...eventData};
    // tmpInputs[idkey] = value;
    // setEventData(tmpInputs);
    // // console.log(tmpInputs);
    // setEventData({...eventData,[idkey]:value});
    setEventData(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: stable callback identity; setEventData is a prop passed in from parent and assumed stable across renders
  }, []);
  const [{ handlerId }, drop] = useDrop({
    accept: "card",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: "card",
    item: () => {
      console.log("dragging");
      console.log(id);
      console.log(index);
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  // const copyEvent = (evt) => {
  //   let tmpEvent = { ...evt };
  //   tmpEvent.name = "Copy of " + tmpEvent.name;
  //   tmpEvent.publicUrl = tmpEvent.publicUrl + "_copy";
  //   tmpEvent.startDate = null;
  //   tmpEvent.endDate = null;
  //   tmpEvent.campaignCode = "";
  //   tmpEvent.campaignCodeVerified = false;
  //   tmpEvent.id = db.collection("events").doc().id;
  //   //copy banner image, mobile and featuerd
  //   //copy carousel when finished.
  //   setCurrentEventData(tmpEvent);
  //   setEventData(tmpEvent);
  //   sessionStorage.setItem("eventData", JSON.stringify(tmpEvent));
  //   history("/manage/event");
  //   // Sentry.captureMessage(
  //   //   "Event " + evt.id + " copied to " + tmpEvent.id + "successfully.",
  //   //   "info"
  //   // );

  //   toast.success("Event copied successfully.");
  // };

  drag(drop(ref));



  const handleListImageRead = async (event, i, x, y) => {
    const file = event.target.files[0];

    const base64 = await convertBase64(file);
    uploadCloudinary(base64, eventData.id + "_" + x + "_" + i, "/pcna/ezentrum/" + eventData.id + "/", x + i, null, x, i, y);

  };
  const fieldList = ['id', 'eventId', 'company', 'title', 'firstName', 'lastName', 'email', 'phone', 'address1', 'address2', 'city', 'state', 'postal', 'country', 'experience', 'purchaseTimeFrame', 'dealer', 'modelInterest', 'adyenResultCode', 'adyenRefusalReason', 'adyenRef', 'adyenRefDate', 'adyenLink', 'adyenLinkId', 'adyenLinkExpire', 'status', 'adyenPayemntStatus', 'hasWaiver', 'createdAt', 'updatedAt', 'leadSent'];
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const handleListChange = async (event, i, x, checkbox) => {
    let tmpList = eventData[x];
    console.log(tmpList);
    if (event.target.name === 'fieldName');
    if (fieldList.indexOf(event.target.value) >= 0) {
      toast.error('Invalid field name, field already in use.');
      return;
    }

    tmpList[i] = { ...tmpList[i], [event.target.name]: checkbox ? event.target.checked : event.target.value };
    console.log(tmpList);
    setEventData({ ...eventData, tmpList: tmpList });
  };
  const uploadCloudinary = (file, pubId, folder, key, transformation, list, i, field) => {
    //uploadCloudinary(base64, eventData.id + "_" + x + "_" + i, "/pcna/ezentrum/" + eventData.id + "/", x + i, null, true, i);

    let uploadData = { file: file, public_id: pubId, folder: folder, transformation: transformation };
    var upload = firebase.functions().httpsCallable("appV2/uploadCloudinary");
    upload(uploadData)
      .then((result) => {
        if (result?.data.message) {
          toast.warning(result?.data.message);
          return "";
        } else {
          toast.success("Image upload successful.");
          let tmpInputs = eventData;
          let u = result.data.url;
          console.log(u);
          console.log(list);
          console.log(key);
          console.log('======')
          //.split("/");
          // u.splice(6,1);
          // u = u.join("/");
          if (!list)
            tmpInputs[key] = u;
          let img = document.getElementById(key);
          console.log(img);
          console.log(key);
          img.src = img.src + "?v=" + Date.now(); // trick browser into reload
          if (!list) {
            setEventData({ ...tmpInputs });
            db.collection("events").doc(tmpInputs.id).set(tmpInputs);

            setEventData(tmpInputs);
            sessionStorage.setItem("eventData", JSON.stringify(tmpInputs));

            setCurrentEventData(tmpInputs);
          } else {
            let tmpImages = eventData[list];
            if (!field) {
              tmpImages[i] = u;
              console.log(tmpImages);
              setEventData({ ...eventData, tmpImages: tmpImages });
            } else {
              console.log(tmpImages);
              tmpImages[i][field] = u;
            }
            setEventData({ ...eventData, tmpImages: tmpImages });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  }
  // useEffect(() => {
  //   let tmpEventData = JSON.parse(sessionStorage.getItem('eventData'));
  //   if(tmpEventData)
  //     setEventData(tmpEventData);
  //   // let tmpEventData = currentEventData;
  //   setEventData(tmpEventData);
  // }, []);

  const labelCls = "block text-sm font-medium text-zinc-700 dark:text-zinc-300";
  const inputCls =
    "mt-2 block w-full rounded-md bg-zinc-50 px-3 py-2 text-sm text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-zinc-900 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:placeholder:text-zinc-500 dark:focus:ring-white";
  const secondaryBtnCls =
    "inline-flex items-center justify-center rounded-md bg-zinc-50 px-3 py-2 text-sm font-semibold text-zinc-900 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:hover:bg-zinc-700";
  const actionBtnCls =
    "inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-md bg-zinc-50 p-2 text-zinc-700 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 disabled:cursor-not-allowed disabled:opacity-40 dark:bg-zinc-800 dark:text-zinc-200 dark:ring-white/10 dark:hover:bg-zinc-700";
  const checkboxCls =
    "h-4 w-4 rounded border-zinc-300 text-zinc-900 focus:ring-zinc-900 dark:border-zinc-600 dark:bg-zinc-800 dark:text-white dark:focus:ring-white";
  const checkboxLabelCls = "inline-flex items-center gap-2 text-sm text-zinc-700 dark:text-zinc-300";
  const helpTextCls = "mt-1 text-xs text-zinc-500 dark:text-zinc-400";
  const getDestinationOptions = (button) => {
    const options = getCTAButtonDestinationOptions(eventData);
    const currentDestination = getCTAButtonDestination(item, button);

    if (
      currentDestination !== "custom" &&
      !options.some(({ value }) => value === currentDestination)
    ) {
      return [
        ...options,
        {
          disabled: true,
          label: `${CTA_BUTTON_DESTINATIONS[currentDestination] || currentDestination} (disabled)`,
          value: currentDestination,
        },
      ];
    }

    return options;
  };
  const button1Destination = getCTAButtonDestination(item);
  const button2Destination = getCTAButtonDestination(item, 2);
  const panelId = `cta-panel-${index}`;

  return (
    <div
      ref={ref}
      style={{ opacity }}
      id={"card-" + index}
      data-handler-id={handlerId}
      className={`mb-3 cursor-move rounded-md border border-dashed border-zinc-400 bg-zinc-50 p-3 dark:border-zinc-600 dark:bg-zinc-900 ${index % 2 === 0 ? "alt-row cta-list-item" : "cta-list-item"}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="truncate text-lg font-semibold text-zinc-900 dark:text-zinc-100">
            CTA #{index + 1}
            {item?.ctaTitle ? ` — ${item.ctaTitle}` : ""}
          </h2>
          {!isExpanded && item?.hideCTA && (
            <span className="text-xs font-medium text-amber-700 dark:text-amber-400">
              Hidden on public pages
            </span>
          )}
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            aria-label={`Move CTA ${index + 1} up`}
            className={actionBtnCls}
            data-testid={`cta-move-up-${index}`}
            disabled={index === 0}
            onClick={() => moveCard(index, index - 1)}
            title="Move up"
            type="button"
          >
            <ChevronUpIcon aria-hidden="true" className="size-5" />
          </button>
          <button
            aria-label={`Move CTA ${index + 1} down`}
            className={actionBtnCls}
            data-testid={`cta-move-down-${index}`}
            disabled={index >= totalItems - 1}
            onClick={() => moveCard(index, index + 1)}
            title="Move down"
            type="button"
          >
            <ChevronDownIcon aria-hidden="true" className="size-5" />
          </button>
          <button
            aria-controls={panelId}
            aria-expanded={isExpanded}
            aria-label={`${isExpanded ? "Collapse" : "Expand"} CTA ${index + 1}`}
            className={actionBtnCls}
            data-testid={`cta-toggle-${index}`}
            onClick={onToggleExpanded}
            title={isExpanded ? "Collapse CTA" : "Expand CTA"}
            type="button"
          >
            {isExpanded ? (
              <ArrowsPointingInIcon aria-hidden="true" className="size-5" />
            ) : (
              <ArrowsPointingOutIcon aria-hidden="true" className="size-5" />
            )}
          </button>
        </div>
      </div>
      <div
        className={isExpanded ? "" : "hidden"}
        data-testid={`cta-panel-${index}`}
        id={panelId}
      >
        <div className="mt-3">
        <label className={checkboxLabelCls}>
          <input
            type="checkbox"
            onChange={(e) => {
              handleListChange(e, index, "ctaList", true);
            }}
            id={"hideCTA" + index}
            name="hideCTA"
            checked={eventData?.ctaList[index].hideCTA || false}
            className={checkboxCls}
          />
          <span>Hide this CTA on public pages</span>
        </label>
        </div>

      {eventData?.ctaLayout !== "OnlyButtons" ? (
        <>
          {eventData?.ctaLayout !== "FullRows" ? (
            <div>
              <div className="mt-4">
                <label className={labelCls}>CTA Image (800x600)</label>
                <div className="mt-2">
                  <input
                    id={"originalFileName" + index}
                    type="file"
                    name="originalFileName"
                    onChange={(e) => handleListImageRead(e, index, 'ctaList', 'ctaImage')}
                    className="block w-full text-sm text-zinc-700 file:mr-3 file:rounded-md file:border-0 file:bg-zinc-200 file:px-3 file:py-1.5 file:text-sm file:font-semibold file:text-zinc-900 hover:file:bg-zinc-300 dark:text-zinc-300 dark:file:bg-zinc-700 dark:file:text-zinc-100 dark:hover:file:bg-zinc-600"
                  />
                </div>
              </div>
              <div className={item.ctaImage ? "banner-image mobile-banner mt-3" : "hidden"}>
                <img id={"ctaList" + index}
                  className=""
                  src={item.ctaImage}
                  alt=""
                />
              </div>
            </div>
          ) : (<div></div>)}
          {eventData?.ctaLayout === "SpacedTiles" ? (
            <>
              <div className="mt-4">
                <label
                  className={`${labelCls} cursor-help`}
                  onClick={() => {
                    setHelp({ ...help, ctaTitle: !help.ctaTitle });
                  }}
                >
                  Subtitle 1
                  <i className="ml-1 align-middle text-xs">
                    <InfoIcon />
                  </i>
                </label>
                <div className={help.name ? helpTextCls : "hidden"}>
                  Subtitle 1
                </div>
                <input
                  type="text"
                  id={"ctaSubtitle1"}
                  name="ctaSubtitle1"
                  value={eventData?.ctaList[index].ctaSubtitle1 || ''}
                  onChange={(e) => { handleListChange(e, index, 'ctaList') }}
                  className={inputCls}
                />
              </div>
              <div className="mt-4">
                <label
                  className={`${labelCls} cursor-help`}
                  onClick={() => {
                    setHelp({ ...help, ctaTitle: !help.ctaTitle });
                  }}
                >
                  Subtitle 2
                  <i className="ml-1 align-middle text-xs">
                    <InfoIcon />
                  </i>
                </label>
                <div className={help.name ? helpTextCls : "hidden"}>
                  Subtitle 2
                </div>
                <input
                  type="text"
                  id={"ctaSubtitle2"}
                  name="ctaSubtitle2"
                  value={eventData?.ctaList[index].ctaSubtitle2 || ''}
                  onChange={(e) => { handleListChange(e, index, 'ctaList') }}
                  className={inputCls}
                />
              </div>
              <div className="mt-4">
                <label
                  className={`${labelCls} cursor-help`}
                  onClick={() => {
                    setHelp({ ...help, ctaTitle: !help.ctaTitle });
                  }}
                >
                  Subtitle 3
                  <i className="ml-1 align-middle text-xs">
                    <InfoIcon />
                  </i>
                </label>
                <div className={help.name ? helpTextCls : "hidden"}>
                  Subtitle 3
                </div>
                <input
                  type="text"
                  id={"ctaSubtitle3"}
                  name="ctaSubtitle3"
                  value={eventData?.ctaList[index].ctaSubtitle3 || ''}
                  onChange={(e) => { handleListChange(e, index, 'ctaList') }}
                  className={inputCls}
                />
              </div>
            </>)
            : (<div></div>)}
          <div className="mt-4">
            <label
              className={`${labelCls} cursor-help`}
              onClick={() => {
                setHelp({ ...help, ctaTitle: !help.ctaTitle });
              }}
            >
              Title{" "}
              <i className="ml-1 align-middle text-xs">
                <InfoIcon />
              </i>
            </label>
            <div className={help.name ? helpTextCls : "hidden"}>
              Title
            </div>
            <input
              type="text"
              id={"ctaTitle" + index}
              name="ctaTitle"
              value={eventData?.ctaList[index].ctaTitle || ''}
              onChange={(e) => { handleListChange(e, index, 'ctaList') }}
              className={inputCls}
            />
          </div>
          <div className="mt-4">
            <label
              className={`${labelCls} cursor-help`}
              onClick={() => {
                setHelp({ ...help, ctaDescription: !help.ctaDescription });
              }}
            >
              Description{" "}
              <i className="ml-1 align-middle text-xs">
                <InfoIcon />
              </i>
            </label>
            <div className={help.name ? helpTextCls : "hidden"}>
              Description.
            </div>
            {/* <textarea
              id={"ctaDescription"}
              name="ctaDescription"
              value={eventData?.ctaList[index].ctaDescription || ''}
              onChange={(e) => { handleListChange(e, index, 'ctaList') }}
              className="form-control"
            /> */}
            <div className="copy-container">
              <div
                className={eventData?.ctaList[index].ctaDescription
                  ? "jodit-preview mb-3 mt-2 rounded-md p-2 text-sm"
                  : "hidden"}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    eventData?.ctaList[index].ctaDescription),
                }}
              ></div>
              <button
                type="button"
                className={secondaryBtnCls}
                onClick={() => { setEditCopy("ctaList_" + index + "_ctaDescription"); }}
              >
                Edit Description
              </button>
            </div>
          </div>

        </>
      ) : (<div></div>)
      }
      <div className="mt-4">
        <label
          className={`${labelCls} cursor-help`}
          onClick={() => {
            setHelp({ ...help, ctaLabel: !help.ctaLabel });
          }}
        >

          Button 1 Label{" "}
          <i className="ml-1 align-middle text-xs">
            <InfoIcon />
          </i>
        </label>
        <div className={help.ctaLabel ? helpTextCls : "hidden"}>
          Button 1 Label.
        </div>
        <input
          type="text"
          id={"ctaLabel" + index}
          name="ctaLabel"
          value={eventData?.ctaList[index].ctaLabel || ''}
          onChange={(e) => { handleListChange(e, index, 'ctaList') }}
          className={inputCls}
        />
      </div>
      <div className="mt-4">
        <label className={labelCls} htmlFor={"ctaLinkType" + index}>
          Button 1 Destination
        </label>
        <select
          className={inputCls}
          id={"ctaLinkType" + index}
          name="ctaLinkType"
          onChange={(e) => { handleListChange(e, index, "ctaList") }}
          value={button1Destination}
        >
          {getDestinationOptions(1).map((option) => (
            <option
              disabled={option.disabled}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {button1Destination === "custom" && (
        <>
          <div className="mt-4">
            <label
              className={`${labelCls} cursor-help`}
              htmlFor={"ctaLink" + index}
              onClick={() => {
                setHelp({ ...help, ctaLink: !help.ctaLink });
              }}
            >
              Button 1 Custom URL{" "}
              <i className="ml-1 align-middle text-xs">
                <InfoIcon />
              </i>
            </label>
            <div className={help.ctaLink ? helpTextCls : "hidden"}>
              Custom URL for Button 1.
            </div>
            <input
              type="text"
              id={"ctaLink" + index}
              name="ctaLink"
              value={eventData?.ctaList[index].ctaLink || ''}
              onChange={(e) => { handleListChange(e, index, 'ctaList') }}
              className={inputCls}
            />
          </div>
          <div className="mt-4">
            <label className={checkboxLabelCls}>
              <input
                type="checkbox"
                onChange={(e) => { handleListChange(e, index, 'ctaList', true) }}
                id={"ctaExternal" + index}
                name="ctaExternal"
                checked={eventData?.ctaList[index].ctaExternal || false}
                className={checkboxCls}
              />
              <span>Open Button 1 in a new window?</span>
            </label>
          </div>
        </>
      )}
      <div className="mt-4">
        <label className={checkboxLabelCls}>
          <input
            type="checkbox"
            onChange={(e) => { handleListChange(e, index, 'ctaList', true) }}
            id={"ctaIcon" + index}
            name="ctaIcon"
            checked={eventData?.ctaList[index].ctaIcon || false}
            className={checkboxCls}
          />
          <span>Large Button 1 (large button vs link)?</span>
        </label>
      </div>
      <div className="mt-4">
        <label
          className={`${labelCls} cursor-help`}
          onClick={() => {
            setHelp({ ...help, ctaLabel2: !help.ctaLabel2 });
          }}
        >

          Button 2 Label{" "}
          <i className="ml-1 align-middle text-xs">
            <InfoIcon />
          </i>
        </label>
        <div className={help.name ? helpTextCls : "hidden"}>
          Button 2 Label.
        </div>
        <input
          type="text"
          id={"ctaLabel2" + index}
          name="ctaLabel2"
          value={eventData?.ctaList[index].ctaLabel2 || ''}
          onChange={(e) => { handleListChange(e, index, 'ctaList') }}
          className={inputCls}
        />
      </div>
      <div className="mt-4">
        <label className={labelCls} htmlFor={"ctaLinkType2" + index}>
          Button 2 Destination
        </label>
        <select
          className={inputCls}
          id={"ctaLinkType2" + index}
          name="ctaLinkType2"
          onChange={(e) => { handleListChange(e, index, "ctaList") }}
          value={button2Destination}
        >
          {getDestinationOptions(2).map((option) => (
            <option
              disabled={option.disabled}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {button2Destination === "custom" && (
        <>
          <div className="mt-4">
            <label
              className={`${labelCls} cursor-help`}
              htmlFor={"ctaLink2" + index}
              onClick={() => {
                setHelp({ ...help, ctaLink2: !help.ctaLink2 });
              }}
            >
              Button 2 Custom URL{" "}
              <i className="ml-1 align-middle text-xs">
                <InfoIcon />
              </i>
            </label>
            <div className={help.ctaLink2 ? helpTextCls : "hidden"}>
              Custom URL for Button 2.
            </div>
            <input
              type="text"
              id={"ctaLink2" + index}
              name="ctaLink2"
              value={eventData?.ctaList[index].ctaLink2 || ''}
              onChange={(e) => { handleListChange(e, index, 'ctaList') }}
              className={inputCls}
            />
          </div>
          <div className="mt-4">
            <label className={checkboxLabelCls}>
              <input
                type="checkbox"
                onChange={(e) => { handleListChange(e, index, 'ctaList', true) }}
                id={"ctaExternal2" + index}
                name="ctaExternal2"
                checked={eventData?.ctaList[index].ctaExternal2 || false}
                className={checkboxCls}
              />
              <span>Open Button 2 in a new window?</span>
            </label>
          </div>
        </>
      )}
      <div className="mt-4">
        <label className={checkboxLabelCls}>
          <input
            type="checkbox"
            onChange={(e) => { handleListChange(e, index, 'ctaList', true) }}
            id={"ctaIcon2" + index}
            name="ctaIcon2"
            checked={eventData?.ctaList[index].ctaIcon2 || false}
            className={checkboxCls}
          />
          <span>Large Button 2 (large button vs link)?</span>
        </label>
      </div>
      <hr className="my-4 border-zinc-200 dark:border-zinc-700" />
      <div className="mt-4">
        <label className={checkboxLabelCls}>
          <input
            type="checkbox"
            onChange={(e) => { handleListChange(e, index, 'ctaList', true) }}
            id={"centered" + index}
            name="centered"
            checked={eventData?.ctaList[index].centered || false}
            className={checkboxCls}
          />
          <span>Content Centered?</span>
        </label>
      </div>

      <div className="mt-4 text-right">
        <button
          aria-label={`Delete CTA ${index + 1}`}
          className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-md p-2 text-red-600 hover:bg-red-50 hover:text-red-700 dark:text-red-500 dark:hover:bg-red-950/40 dark:hover:text-red-400"
          onClick={() => onRemove(index)}
          title="Delete CTA"
          type="button"
        >
          <DeleteIcon />
        </button>
      </div>
      </div>

      <VisualEditorModal
        changeItem={handleChangeItem}
        fieldList={fieldList}
        idkey={editCopy}
        onClose={() => setEditCopy(null)}
        value={eventData}
      />
    </div>
  );
};
